import { useContext } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../api";
import { OverflowFrame } from "../../../externalComponents";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { Button } from "../../../externalComponents/tailwind/button";
import { Heading } from "../../../externalComponents/tailwind/heading";
import { Text } from "../../../externalComponents/tailwind/text";
import { cleanPhone } from "../../../functions/cleanPhone";
import { CustomerContext } from "../../../providers";

export default function WhatsappProfilePage() {
  const { customer } = useContext(CustomerContext);

  // Facebook Login with JavaScript SDK
  function launchWhatsAppSignup() {
    // Launch Facebook login
    // eslint-disable-next-line no-undef
    FB.login(
      (response) => {
        console.log(response);
        if (response.authResponse) {
          const accessToken = response.authResponse.code;
          // Use this token to call the debug_token API and get the shared WABA's ID
          console.log(
            `Use this token to call the debug_token API and get the shared WABA's ID: ${accessToken}`,
          );
          api.finishEmbeddedSignup({
            accessToken,
            customerId: customer.id,
          });
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: "993629832266228", // configuration ID obtained in the previous step goes here
        response_type: "code", // must be set to 'code' for System User access token
        override_default_response_type: true,
        extras: {
          setup: {
            phone: {
              displayName: customer?.name,
              category: "RETAIL",
            },
          },
          featureType: "whatsapp_business_app_onboarding",
        },
      },
    );
  }

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="Business Profile" />
        <OverflowFrame>
          <div className="my-5">
            {(customer?.apiKey360Dialog || customer?.waAccessToken) && (
              <>
                <Heading className="text-lg mb-5">
                  Your WhatsApp account is connected 🎉
                </Heading>

                <Button
                  color="secondaryButton"
                  onClick={() =>
                    window.open(
                      "https://business.facebook.com/wa/manage/phone-numbers/",
                      "_blank",
                    )
                  }
                >
                  Edit WhatsApp profile
                </Button>
                <br />
                <br />
                {customer?.phoneNumber && (
                  <Text>
                    Phone number:{" "}
                    <Link
                      className="text-pink"
                      target="_blank"
                      to={`https://wa.me/${cleanPhone(customer.phoneNumber)}`}
                    >
                      +{cleanPhone(customer.phoneNumber)}
                    </Link>
                  </Text>
                )}
                <br />
              </>
            )}
            {!customer?.apiKey360Dialog &&
              !customer?.waAccessToken &&
              customer?.isSubscribed && (
                <>
                  <button
                    onClick={launchWhatsAppSignup}
                    style={{
                      backgroundColor: "#1877f2",
                      border: "0",
                      borderRadius: "4px",
                      color: "#fff",
                      cursor: "pointer",
                      fontFamily: "Helvetica, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "bold",
                      height: "40px",
                      padding: "0 24px",
                    }}
                  >
                    Continue with Facebook
                  </button>
                  {/* <Button
                    color="secondaryButton"
                    onClick={() =>
                      openSignInWindow(
                        url360,
                        "connect-360dialog",
                        window.location.origin
                      )
                    }
                  >
                    Create a WhatsApp account
                  </Button> */}
                </>
              )}
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
